import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSimpleAuth } from '../../contexts/SimpleAuthContext';
import './AuthForms.css';

export const ForgotPasswordForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [validationError, setValidationError] = useState('');
  
  const { requestPasswordReset, error, clearError } = useSimpleAuth();

  const validateForm = () => {
    if (!email) {
      setValidationError('Email is required');
      return false;
    }
    
    if (!/\S+@\S+\.\S+/.test(email)) {
      setValidationError('Please enter a valid email address');
      return false;
    }
    
    setValidationError('');
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    clearError();
    
    try {
      await requestPasswordReset(email);
      setIsSubmitted(true);
    } catch (err) {
      // Error is handled by context
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2 className="auth-title">Check Your Email</h2>
          <div className="auth-info-message">
            If an account exists with {email}, we've sent password reset instructions to that email address.
          </div>
          <p className="auth-subtitle">
            The link in the email will expire in 1 hour for security reasons.
          </p>
          <Link to="/auth/login" className="auth-submit-button" style={{ textAlign: 'center', display: 'block' }}>
            Return to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Reset Your Password</h2>
        <p className="auth-subtitle">
          Enter your email address and we'll send you instructions to reset your password.
        </p>
        
        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={validationError ? 'error' : ''}
              placeholder="you@example.com"
              autoComplete="email"
              autoFocus
            />
            {validationError && (
              <span className="field-error">{validationError}</span>
            )}
          </div>
          
          <button
            type="submit"
            className="auth-submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Reset Instructions'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>
            Remember your password?{' '}
            <Link to="/auth/login" className="auth-link">
              Sign in instead
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};